import Util from 'root/module/util';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    installed_domains: [],

    verifying: true,

    events: {
        'click .verify-again': 'onVerifyAgain'
    },

    dom_handlers: {
        onVerifyAgain: function(e) {
            e.preventDefault();

            this.verifying = true;
            this.render();
        }
    },

    initialize: function(options) {
        this.project_id = options.project_id;

        this.on('remove', () => {
            clearTimeout(this.check_timeout);
        });
    },

    loadInstallDomains: function() {
        Cache.app.request({
            action: 'js_snippet/getCodeInstallDomain',
            success: (response) => {
                this.verifying = false;

                this.installed_domains = response.domains;
                this.render();
            }
        });
    },

    render: function() {
        var project_domains = [];

        if (this.project_id) {
            project_domains = Cache.project_domain.where({project_id: this.project_id});
        } else {
            // all projects
            project_domains = Cache.project_domain;
        }

        // get unique domains
        project_domains = project_domains.filter((model, index, self) => {
            return self.findIndex((m) => m.get('domain') === model.get('domain')) === index;
        });

        var content = '';

        if (project_domains.length) {
            var installed_count = 0;

            project_domains.map((model) => {
                var is_installed = this.installed_domains.some((domain) => {
                    return Util.matchDomain(domain, model.get('domain'));
                });

                if (is_installed) {
                    installed_count++;
                }
            });

            content =
            '<div class="flex-between">' +
                '<div>' +
                    (this.verifying ?
                    'Verifying ' + project_domains.length + ' domain' + (project_domains.length === 1 ? '' : 's') + '...' :
                    installed_count + ' of ' + project_domains.length + ' domain' + (project_domains === 1 ? '' : 's') + ' verified') +
                '</div>' +
                '<a href="#" class="verify-again primary font-weight-medium"' + (this.verifying ? ' style="display:none;"' : '') + '>Try again</a>' +
            '</div>' +

            '<div class="code-install-verify-domains box-small-large margin-top-12 grid-gap-16">' +
            project_domains.map((model) => {
                var is_installed = this.installed_domains.some((domain) => {
                    return Util.matchDomain(domain, model.get('domain'));
                });

                return '' +
                '<div>' +
                    '<div>' + (model.get('domain').startsWith('http') ? '' : 'https://') + model.escape('domain') + '</div>' +
                    '<div class="text-medium margin-top-8">' +
                        (this.verifying ?
                        '<span class="text-info"><i class="fa-duotone fa-loader fa-spin"></i> Verifying...</span>' :
                        (is_installed ?
                        '<span class="text-success font-weight-medium"><i class="fa-solid fa-circle-check"></i> Verified</span>' :
                        '<span class="text-warning font-weight-medium"><i class="fa-solid fa-triangle-exclamation"></i> Code not found</span>')) +
                    '</div>' +
                '</div>';
            }).join('') +

            '</div>';
        } else {
            content =
                '<p class="text-info italic">No project domains added.</p>' +
                '<p>Please add your project domains first before we can verify the code installation for you.</p>';
        }

        this.$el.html(content);

        if (this.verifying && project_domains.length) {
            // check every 2 seconds
            this.check_timeout = setTimeout(() => {
                this.loadInstallDomains();
            }, 2000);
        }

        return this;
    }
});